<template>
  <div :class="[getTabClass, getNoPaddingClass]">
    <v-tabs-items :value="value">
      <slot></slot>
    </v-tabs-items>
  </div>
</template>

<script>
import { AscTabPropsMixin } from '@/components/mixins'

export default {
  name: 'AscTabBody',

  mixins: [AscTabPropsMixin],

  props: {
    maxTabs: {
      type: Number,
      default: 10,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getTabClass() {
      return !this.noPadding
        ? `asc-tab__content--${this.secondary ? 'secondary' : 'primary'}`
        : ''
    },
    getNoPaddingClass() {
      return this.maxTabs === 1 ? 'asc-tab__content--no-padding' : ''
    },
  },

  watch: {
    maxTabs(newValue) {
      this.maxTabs = newValue
    },
  },
}
</script>

<style lang="scss">
.asc-tab__content {
  &--secondary {
    background-color: $gray-0 !important;
  }

  &--primary,
  &--secondary {
    padding: 16px;

    .v-tabs-items {
      overflow: unset;

      &.theme--light {
        background-color: unset;
      }
    }
  }

  &--no-padding {
    padding-top: 0;
    padding-bottom: 12px;
  }
}
</style>
